<template>
  <div id="customer" class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-gutter-md justify-center">
        <div class="col-12">
          <q-btn
            color="primary"
            id="addBtn"
            @click="toAddCustomer"
            label="添加客户"
            icon="person"
          />
        </div>
        <div class="col-md-3 col-11">
          <q-input
            filled
            v-model="queryForm.customerName"
            label="客户名称"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn
            label="重置"
            type="reset"
            color="primary"
            flat
            class="q-ml-sm"
          />
        </div>
      </div>
    </q-form>

    <q-table
      ref="mytable"
      title="客户信息"
      :data="tableData.list"
      :columns="columns"
      row-key="customerNo"
      :pagination.sync="pagination"
      :loading="loading"
      :filter="filter"
      @request="request"
      binary-state-sort
      separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]"
    >
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm">
            <q-btn
              round
              color="primary"
              size="xs"
              icon="edit"
              @click="handleEdit(props.rowIndex, props.row)"
            />
            <q-btn
              round
              color="deep-orange"
              size="xs"
              icon="delete_forever"
              @click="removeCustomer(props.row)"
            />
          </div>
        </q-td>
      </template>
    </q-table>

    <cust-dialog :visible.sync="visible" :customer="customer" @query="query" />
  </div>
</template>

<script>
import CustDialog from "@/views/erp/customer/custDialog.vue";
import { removeCust } from "@/api/erp/customer.js";
export default {
  components: {
    CustDialog,
  },
  data() {
    return {
      filter: "",
      loading: false,
      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "customerNo",
          align: "center",
          label: "客户编号",
          field: "customerNo",
        },
        {
          name: "customerName",
          align: "center",
          label: "客户名称",
          field: "customerName",
        },
        {
          name: "customerShortName",
          align: "center",
          label: "客户简称",
          field: "customerShortName",
          sortable: true,
        },
        {
          name: "taxNo",
          align: "center",
          label: "税号",
          field: "taxNo",
          sortable: true,
        },
        {
          name: "address",
          align: "center",
          label: "地址",
          field: "address",
        },
        {
          name: "telephone",
          align: "center",
          label: "电话",
          field: "telephone",
          sortable: true,
        },
        {
          name: "openBank",
          align: "center",
          label: "开户行",
          field: "openBank",
          sortable: true,
        },
        {
          name: "account",
          align: "center",
          label: "帐号",
          field: "account",
          sortable: true,
        },
        {
          name: "bankNo",
          align: "center",
          label: "行号",
          field: "bankNo",
          sortable: true,
        },
        {
          name: "contact",
          align: "center",
          label: "联系人",
          field: "contact",
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
      tableData: [],
      visible: false,
      customer: {},
      queryForm: {},
    };
  },
  methods: {
    toAddCustomer() {
      // this.$router.push("/customer/add");
      this.customer = {};
      this.visible = true;
    },
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      this.$axios
        .get("customer/query", { params: self.queryForm })
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.tableData = response.data.data;
            self.pagination.rowsNumber = self.tableData.total;
            // don't forget to update local pagination object
            self.pagination.page = page;
            self.pagination.rowsPerPage = rowsPerPage;
            self.pagination.sortBy = sortBy;
            self.pagination.descending = descending;
            // ...and turn of loading indicator
            self.loading = false;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    removeCustomer(row) {
      var self = this;

      this.$q
        .dialog({
          title: "请谨慎操作",
          message: "此操作将永久删除该条记录, 是否继续?",
          cancel: "取消",
          ok: "确定",
          persistent: true,
        })
        .onOk(() => {
          console.log(">>>> OK");
          removeCust(row.id).then(function (response) {
            if (response.data.errorCode == "00000") {
              self.$q.notify({ type: "positive", message: "删除成功" });
              self.query();
            } else {
              self.$q.notify({
                type: "negative",
                message: response.data.errorMsg,
              });
            }
          });
        })
        .onCancel(() => {
          self.$q.notify({ type: "info", message: "已取消删除" });
        })
        .onDismiss(() => {
          console.log("I am triggered on both OK and Cancel");
        });
    },
    handleEdit(index, row) {
      console.log(JSON.stringify(row));
      this.customer = JSON.parse(JSON.stringify(row));
      this.visible = true;
    },
  },
  created: function () {
    console.log("mobileApp created");
  },
  mounted: function () {
    this.$refs.mytable.requestServerInteraction();
  },
};
</script>

<style scoped>
#addBtn {
  float: right;
}
#queryForm {
  /* margin-top: 20px; */
  margin-bottom: 20px;
}
</style>